module.exports = __webpack_public_path__ + "img/image01.115eb650.jpg";